module.exports = __webpack_public_path__ + "img/leftside_300.ae0401f4.png";